import axios from 'axios';

import { resolveBeEndpoint } from '../lib/endpointResolver';
import { resolveOrgFromHostname } from '../lib/org';
import type { LocaleBundle } from '../locales';

// Shared BE translations endpoint, scoped to the `finder` namespace (keys `finder.*`).
// Not via apiClient: camelize would mangle dotted keys.
const NAMESPACE = 'finder';
const KEY_PREFIX = `${NAMESPACE}.`;

export async function fetchTranslations(lang: string): Promise<LocaleBundle> {
  try {
    const apiRoot = `${resolveBeEndpoint().replace(/\/+$/, '')}/core/v1`;
    const org = resolveOrgFromHostname();
    const { data } = await axios.get<Record<string, string>>(
      `${apiRoot}/locales/${lang}/${NAMESPACE}.json`,
      {
        timeout: 15000,
        headers: {
          Accept: 'application/json',
          ...(org ? { organization: org } : {}),
        },
      },
    );

    // Keep only `finder.*` keys; they overlay the like-keyed local bundle as-is.
    return Object.entries(data ?? {}).reduce<LocaleBundle>((acc, [key, value]) => {
      if (key.startsWith(KEY_PREFIX)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  } catch (err) {
    console.error('[translationService] fetchTranslations failed', { lang, err });
    throw err;
  }
}
